import { useCallback, useContext, useState, useEffect } from "react"; //evita que se vuelva a ejecutar una funcion
import UserContext from "context/UserContext";
//Firebase
import "firebase/auth";
import { useFirebaseApp, useUser as useUserFirebase } from "reactfire";
import Firebase from "firebase/app";
import { db } from "../firebase";
import { IMGUR_CLIENT_ID } from "apis/private/apis";

export default function useImgur() {
  let ImageUpload = function (image) {
    return new Promise(function (resolve, reject) {
      const formdata = new FormData();
      formdata.append("image", image);

      fetch("https://api.imgur.com/3/image/", {
        method: "post",
        headers: {
          Authorization: "Client-ID " + IMGUR_CLIENT_ID,
        },
        body: formdata,
      }).then((data) => {
        data.json().then((data) => {
          console.log(data);
          resolve(data); // ¡Todo salió bien!
        });
      });
    });
  };

  return {
    ImageUpload,
  };
}
